(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/components/animated-background/balloons-background.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/components/animated-background/balloons-background.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState;
const getGsap = () => typeof window === 'undefined' ? null : window.gsap;
const preloadImage = imageSrc => new Promise(resolve => {
  if (!imageSrc || typeof window === 'undefined') {
    resolve();
    return;
  }
  const image = new window.Image();
  let hasResolved = false;
  const done = () => {
    if (hasResolved) {
      return;
    }
    hasResolved = true;
    image.onload = null;
    image.onerror = null;
    resolve();
  };
  image.onload = done;
  image.onerror = done;
  image.src = imageSrc;
  if (image.complete) {
    done();
  }
});
const BalloonsBackground = _ref => {
  var _svs, _ticketInfo$backgroun;
  let ticketInfo = _ref.ticketInfo;
  const containerRef = useRef(null);
  const animationRef = useRef(null);
  const delayRef = useRef(null);
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isImageLoaded = _useState2[0],
    setIsImageLoaded = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasDelayElapsed = _useState4[0],
    setHasDelayElapsed = _useState4[1];

  const cdnUrl = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.core) === null || _svs === void 0 || (_svs = _svs.config) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.svsconfig) === null || _svs === void 0 ? void 0 : _svs.cdn2;
  const backgroundImageData = (_ticketInfo$backgroun = ticketInfo.backgroundThemes) === null || _ticketInfo$backgroun === void 0 || (_ticketInfo$backgroun = _ticketInfo$backgroun[0]) === null || _ticketInfo$backgroun === void 0 ? void 0 : _ticketInfo$backgroun.image;
  const backgroundImageSrc = backgroundImageData ? "".concat(cdnUrl).concat(backgroundImageData.url) : null;
  const backgroundImageStyle = backgroundImageSrc ? {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: '8%',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundImage: "url(\"".concat(backgroundImageSrc, "\")"),
    willChange: 'transform, opacity',
    opacity: 0,
    visibility: 'hidden'
  } : {};
  useEffect(() => {
    if (!backgroundImageSrc) {
      return undefined;
    }
    let isCancelled = false;
    setIsImageLoaded(false);
    setHasDelayElapsed(false);
    (async () => {
      await preloadImage(backgroundImageSrc);
      if (!isCancelled) {
        setIsImageLoaded(true);
      }
    })();
    delayRef.current = window.setTimeout(() => {
      setHasDelayElapsed(true);
    }, 200);
    return () => {
      isCancelled = true;
      if (delayRef.current) {
        clearTimeout(delayRef.current);
        delayRef.current = null;
      }
    };
  }, [backgroundImageSrc]);
  useEffect(() => {
    var _animationRef$current, _animationRef$current2;
    const gsap = getGsap();
    const container = containerRef.current;
    if (!gsap || !container || !backgroundImageSrc || !isImageLoaded || !hasDelayElapsed) {
      return undefined;
    }
    (_animationRef$current = animationRef.current) === null || _animationRef$current === void 0 || (_animationRef$current2 = _animationRef$current.kill) === null || _animationRef$current2 === void 0 || _animationRef$current2.call(_animationRef$current);
    gsap.set(container, {
      y: '-120%',
      x: 0,
      rotation: 0,
      opacity: 0,
      visibility: 'visible'
    });
    const timeline = gsap.timeline();
    timeline.to(container, {
      y: '0%',
      opacity: 1,
      duration: 1.45,
      ease: 'power2.out'
    });
    timeline.to(container, {
      x: '-5px',
      rotation: -1,
      duration: 0.2,
      repeat: 6,
      yoyo: true,
      ease: 'sine.inOut'
    }, 0);
    timeline.to(container, {
      x: '4px',
      rotation: 0.8,
      duration: 0.2,
      repeat: 6,
      yoyo: true,
      ease: 'sine.inOut'
    }, 0);
    animationRef.current = timeline;
    return () => {
      timeline.kill();
      if (animationRef.current === timeline) {
        animationRef.current = null;
      }
    };
  }, [backgroundImageSrc, hasDelayElapsed, isImageLoaded]);
  if (!backgroundImageStyle.backgroundImage) {
    return null;
  }
  return React.createElement("div", {
    ref: containerRef,
    style: backgroundImageStyle
  });
};
setGlobal('svs.tickets.next.components.animatedBackground.BalloonsBackground', BalloonsBackground);

 })(window);